export default "__VITE_ASSET__Ckm1zPll__"